<template>
  <div>
    <el-form
      style="padding: 0;"
      label-position="top"
      label-width="100px"
      :model="centerAccountForm"
    >
      <div class="row no-gutters card-box">
        <div class="col-xs-12 col-md mr-md-4 d-flex justify-content-center justify-content-md-end">
          <div class="single-form ">
            <el-form-item label="센터">
              <el-input
                class="name"
                v-model="centerAccountForm.name"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item label="센터 코드">
              <div
                v-for="code in centerAccountForm.code"
                class="code"
              >
                {{ code }}
              </div>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                센터 로고
                <span class="label-description">
                  (400 x 400px 사이즈 권장/jpg, png 지원/최대 3MB)
                </span>
              </div>

              <CenterLogoUploadField
                :origin-logo-image-src="centerAccountForm.logo"
                @change="onLogoImageChanged"
              />
            </el-form-item>
          </div>
        </div>

        <div class="col-xs-12 col-md ml-md-4 d-flex justify-content-center justify-content-md-start">
          <div class="single-form">
            <el-form-item label="센터 주소">
              <AddressInputWithMap
                :map-visible="true"
                :address="centerAccountForm.address"
                @change="onAddressChange"
              />
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="d-md-flex justify-content-between mt-3 no-gutters">
        <div class="col" />
        <div class="col-12 col-md-6 py-3 px-5 px-md-0 form-bottom-description">
          센터 공식 명칭 변경은 <strong>피플박스 헬프센터</strong>‌로 문의해주시길 바랍니다.
        </div>

        <div class="col d-flex justify-content-end align-items-end">
          <div>
            <el-loading-button
              class="gray"
              :is-loading="isSavingForm"
              :disabled="!isCenterInfoChanged"
              @click="saveCenterInfoForm"
            >
              저장
            </el-loading-button>
            <el-button class="light-gray">
              취소
            </el-button>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import mapView from '@/directives/MapView.js';
import { computedGetters } from '../../utils/vuex-helper';
import ElLoadingButton from '../../components/el-loading-button';
import _ from 'lodash';
import { getFullAddressWithOpeningWindow } from '../../utils/etc';
import CenterLogoUploadField from '../../components/CenterLogoUploadField';
import AddressInputWithMap from '../../components/AddressInputWithMap';

export default {
  name: 'CenterInfo',
  components: { AddressInputWithMap, CenterLogoUploadField, ElLoadingButton },
  directives: { mapView },
  data() {
    return {
      centerAccountForm: {
        address: '',
        logo: '',
        latitude: null,
        longitude: null
      },
      isSavingForm: false
    };
  },
  computed: {
    ...computedGetters(['centerAccount']),
    isCenterInfoChanged() {
      return (
        this.centerAccountForm.address != this.centerAccount.address ||
        this.centerAccountForm.logo != this.centerAccount.logo
      );
    }
  },
  async created() {
    await this.$store.dispatch('syncCenterAccount');
    this.centerAccountForm = _.cloneDeep(this.$store.getters.getCenterAccount);
  },
  methods: {
    onLogoImageChanged(image) {
      this.centerAccountForm.logo = image;
    },
    async saveCenterInfoForm() {
      this.isSavingForm = true;

      try {
        await this.$store.dispatch(
          'updateCenterAccount',
          this.centerAccountForm
        );
        await this.$store.dispatch('syncCenterAccount');
      } catch (err) {
        console.error(err);
      }

      this.$message('센터 정보가 저장됐습니다.');
      this.isSavingForm = false;
    },
    onAddressChange({ address, coordinate }) {
      this.centerAccountForm.address = address;
      this.centerAccountForm.latitude = coordinate.latitude;
      this.centerAccountForm.longitude = coordinate.longitude;
    }
  }
};
</script>

<style lang="scss">
.map-view {
  margin-top: 15px;
  width: 100%;
  height: 235px;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
}
.single-form {
  .name.el-input.is-disabled {
    input {
      -webkit-text-fill-color: #b9b9b9;
    }
  }

  .code {
    display: inline-block;
    width: 40px;
    height: 50px;
    border-radius: 4px;
    border: 1px solid #d3d3d3;
    background-color: #f2f2f2;
    margin-right: 10px;

    color: #4a4a4a;
    font-size: 18px;
    font-weight: normal;

    line-height: 50px;
    box-sizing: border-box;
    text-align: center;
  }
}

.logo-upload-fields {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  background-color: #f2f2f2;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border: dotted 1px #b9b9b9;
  cursor: pointer;
  position: relative;

  input[type='file'] {
    display: none;
  }

  &:hover {
    border: dotted 1px #4a4a4a;
  }
}
</style>
